import type { IconType } from 'react-icons';
import { cx } from './cx';

export type IconMedallionSize = 'sm' | 'md' | 'lg' | 'xl';
export type IconMedallionTone = 'peach' | 'glass';

export interface IconMedallionProps {
  /** A Lucide icon from react-icons/lu, e.g. LuClock. */
  icon: IconType;
  /** sm 46px, md 54px (default), lg 68px, xl 84px. */
  size?: IconMedallionSize;
  /** peach on light surfaces; glass (translucent white) on gradients. */
  tone?: IconMedallionTone;
  /**
   * Set only when the icon carries meaning that no nearby text says. Without
   * it the medallion is decorative and hidden from assistive technology.
   */
  label?: string;
  className?: string;
}

/** Round medallion holding one Lucide icon. */
export function IconMedallion({
  icon: Icon,
  size = 'md',
  tone = 'peach',
  label,
  className,
}: IconMedallionProps) {
  const a11y = label ? { role: 'img', 'aria-label': label } : { 'aria-hidden': true as const };
  return (
    <span
      {...a11y}
      className={cx('ee-medallion', `ee-medallion--${size}`, `ee-medallion--${tone}`, className)}
    >
      <Icon className="ee-medallion__icon" aria-hidden="true" focusable="false" />
    </span>
  );
}
